/* eslint-disable max-classes-per-file */
import { deserialize } from 'cerialize'
import { ShortDataModel, ReceivingFileModel } from 'Models'
import { SpecialOfferModel } from 'Pages/referenceBooks'
import { ProductSlugs } from 'Constants/ProductSlugs'
import { ClientType } from 'Pages/orders_design'
import { MerchantShortInfoModel, IntegrationChannelModel } from 'Pages/orders'

export class AttachmentProduct extends ReceivingFileModel {
	@deserialize public owner_id: number
	@deserialize public owner_type: string
}

export class ProductModel {
	@deserialize public id: number = null
	@deserialize public name = ''
	@deserialize public abbreviation = ''
	@deserialize public integration_code = ''
	@deserialize public sbercrm_name = ''
	@deserialize public slug: ProductSlugs
	@deserialize public include_to_partner = false
	@deserialize public online_option = false
	@deserialize public reserve_account = false
	@deserialize public commentable = false
	@deserialize public account_by_sber_online = false
	@deserialize public fields: string[] = []
	@deserialize public required_fields: string[] = []
	@deserialize public hidden_fields: string[] = []
	@deserialize public merchant_id?: number = null
	@deserialize public knowledge_url = ''
	@deserialize public merchant?: MerchantShortInfoModel = null
	@deserialize public is_deleted?: boolean = false
	@deserialize public skip_call = false
	@deserialize public skip_integration = false
	@deserialize public deal_option = false
	@deserialize public priority = 500
	@deserialize public priority_group: number
	@deserialize public product_group: ShortDataModel = null
	@deserialize public required_products: ShortDataModel[] = []
	@deserialize public add_info = ''
	@deserialize public description_updated_at: string
	@deserialize public integration_channels: IntegrationChannelModel[] = []
	@deserialize public rbidos_type_paid: string
	@deserialize public rbidos_type_paid_lite: string
	@deserialize public is_free_service: boolean
	@deserialize public rbidos_type_free: string
	@deserialize public only_rbidos_type = false
	@deserialize public online_fields: string[]
	@deserialize public online_required_fields: string[]
	@deserialize public min_company_existence: number = null
	@deserialize public block_product_group_ids: string[]
	@deserialize public iskra_code: string
	@deserialize public show_name: string
	@deserialize public description: string
	@deserialize public attachment: AttachmentProduct = null
	@deserialize public attachment_attributes?: File
	@deserialize public integration_channel_ids?: string[]
	@deserialize public required_product_ids?: string[]
	@deserialize public special_offer_ids?: string[]
	@deserialize public special_offers?: SpecialOfferModel[]
	@deserialize public osn_partner_amount_of_remuneration?: number
	@deserialize public usn_partner_amount_of_remuneration?: number
	@deserialize public client_type?: ClientType
	@deserialize public customer_logo?: ReceivingFileModel
	@deserialize public customer_logo_file_name?: string
	@deserialize public available_lk_neo?: boolean
	@deserialize public sbercrm_code?: string
	@deserialize public customer_name: string
	public constructor(data?) {
		if (data) {
			Object.keys(data).forEach((key: string) => {
				this[key] = data[key]
			})
		}
	}
}
